import React from 'react';
import {
  FormControl,
  TextField,
  Typography
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

//css
import StylesCss from './styles';
const useStyles = StylesCss();

export default ({
  escolhaCondicao,
  opcoesCondicao,
  handlerChangeEscolhaCondicao,
  width
}) => {
  const classes = useStyles();

  console.log(escolhaCondicao, opcoesCondicao)

  const handlerOnChange = (event, newValue) => {
    if (newValue == null) return;
    handlerChangeEscolhaCondicao(newValue);
  };

  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      style={{ width: (width != null) ? width : "60%" }}
    >
      <Typography className={classes.titlePopover}>
        Condições de pagamentos
      </Typography>
      <Autocomplete
        id="lb_id_condicoes"
        className={classes.autocomplete}
        options={opcoesCondicao}
        getOptionLabel={o => o.name}
        value={escolhaCondicao}
        onChange={handlerOnChange}
        loadingText={"Carregando..."}
        renderInput={params => (
          <TextField
            {...params}
            variant={"standard"}
            placeholder={"Condicao"}
            fullWidth
          />
        )}
      />
    </FormControl>
  );
};
